import styled, { css } from 'styled-components';
import { px2rem, gridContainer, setGridColumns, mq, getSpace } from '../../../stylesheets/tools';
import { colorThemes } from '../../../stylesheets/themes';

const StyledHeroTeaser = styled.section`
  & + & {
    margin-top: -80px;

    ${mq('m')} {
      margin-top: -150px;
    }
  }

  .teaser__shape {
    margin-bottom: -2px;
    clip-path: polygon(6% 0, 98% 40%, 100% 100%, 0 100%, 2% 26%);

    ${props =>
      props.useBackground &&
      props.colorScheme &&
      css`
        height: 80px;
        background-color: ${props.accessibilityDefaultTheme
          ? props.theme.siteTheme.secondary
          : colorThemes[props.colorScheme].secondary};
      `};
  }

  .teaser__section {
    padding: ${px2rem('40px')} 0 ${px2rem('120px')} 0;
    ${mq('m')} {
      padding: ${px2rem('50px')} 0 ${px2rem('170px')} 0;
    }
    ${props =>
      props.useBackground &&
      props.colorScheme &&
      css`
        background-color: ${props.accessibilityDefaultTheme
          ? props.theme.siteTheme.secondary
          : colorThemes[props.colorScheme].secondary};
      `};
  }
  .teaser__container {
    ${gridContainer()}
    ${setGridColumns('1fr', 1)}
    gap: 20px;

    ${mq('m')} {
      ${setGridColumns('1fr', 2)}
    }

    .teaser__content {
      max-width: 580px;
      justify-content: center;
      display: flex;
      flex-direction: column;

      ${mq('m')} {
        padding-right: 60px;
      }

      .teaser__subline {
        max-width: 390px;
      }
      .teaser__headline {
        margin-bottom: ${getSpace('xs')};
      }
      .teaser__copy {
        margin-bottom: ${getSpace('xs')};
      }
    }

    .teaser__image-item {
      aspect-ratio: 4/3;
      object-fit: cover;
    }
  }
`;

export default StyledHeroTeaser;
